var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMydata(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 11.3 9.6",
    style: {
      enableBackground: "new 0 0 11.3 9.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#242E38;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.6,9.6c-0.7,0-1.5,0-2.2,0C0.1,9.6,0,9.5,0,9.2C0,8.1,0,7,0,6c0-0.8,0.5-1.4,1.3-1.6c0.1,0,0.2,0,0.4,0 c0.7,0,1.3,0,2,0c0.8,0,1.4,0.5,1.6,1.3c0,0.1,0,0.3,0,0.4c0,1.1,0,2.1,0,3.2c0,0.3-0.1,0.4-0.4,0.4C4.1,9.6,3.4,9.6,2.6,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.6,0c1.1,0,2,0.9,2,1.9c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2C0.7,0.9,1.6,0,2.6,0z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.7,2.8H6.3v1.2h4.4c0.3,0,0.6-0.3,0.6-0.6C11.3,3,11,2.8,10.7,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.7,5.2H6.3v1.2h4.4c0.3,0,0.6-0.3,0.6-0.6C11.3,5.5,11,5.2,10.7,5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.7,7.6H6.3v1.2h4.4c0.3,0,0.6-0.3,0.6-0.6C11.3,7.9,11,7.6,10.7,7.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMydata);
export default __webpack_public_path__ + "static/media/My data.64691b07afed275a5b827fa2d3bca9dc.svg";
export { ForwardRef as ReactComponent };